import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Anchor } from '../anchor';
import { Typobold } from '../typobold';

interface AnchorBlockProps extends WithTranslation {
    id: string;
    title: string;
    items: JSX.Element | JSX.Element[];
    noValue?: string;
    action?: JSX.Element;
    /** Optional control rendered on the right of the title row (e.g. a toggle). */
    titleAction?: JSX.Element;
    loader?: JSX.Element;
    cardStyle?: React.CSSProperties;
}

const AnchorBlock = (props: AnchorBlockProps): JSX.Element => {
    const classes = useStyles();
    const { t, title, id, items, noValue, action, titleAction, loader, cardStyle = {} } = props;
    const isArray = Array.isArray(items);

    if (!items || (isArray && items?.length <= 0)) {
        cardStyle.backgroundColor = 'white';
    }

    return (
        <div>
            <br />
            <Anchor id={id} />
            {titleAction ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typobold>{title}</Typobold>
                    {titleAction}
                </div>
            ) : (
                <Typobold>{title}</Typobold>
            )}
            {loader}
            {!loader && (
                <Card className={classes.card} style={{ ...cardStyle }}>
                    <CardContent className={classes.cardContent}>
                        {(!items || (isArray && items?.length <= 0)) && <div>{noValue ?? t('noValue')}</div>}
                        {items && isArray && items.map((element) => element)}
                        {action && (
                            <>
                                <br />
                                {action}
                                <br />
                            </>
                        )}
                        {!isArray && items}
                    </CardContent>
                </Card>
            )}
            <br />
        </div>
    );
};

//=====================================//
//=============== Style ===============//
//=====================================//

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            display: 'flex',
            marginTop: 8,
        },
        cardContent: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
        },
    }),
);

export default withTranslation(['common'])(AnchorBlock);
